import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_3 = {
  key: 1,
  class: "modal-notification-body"
}

import { VIconSvg } from "@/components";
import TModal from "vue-tailwind/dist/t-modal";
import { computed, useSlots } from "vue";
import { isExistSlot } from "@/plugins/helpers";

interface Props {
  clickToClose?: boolean;
  escToClose?: boolean;
  value?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VModalNotification',
  props: {
    clickToClose: { type: Boolean, default: true },
    escToClose: { type: Boolean, default: true },
    value: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;
const slots = useSlots();

const props = __props;

const modalClasses = computed(() => {
  return {
    overlay: "z-50 bg-mirage bg-opacity-45 outline-none",
    wrapper: `flex items-center flex-col z-50 px-3 py-12`,
    modal: `t-modal w-min bg-white shadow-outer rounded-3xl`,
    overlayEnterClass: "opacity-0",
    overlayEnterActiveClass: "transition ease-out duration-300",
    overlayEnterToClass: "opacity-100",
    overlayLeaveClass: "opacity-100",
    overlayLeaveActiveClass: "transition ease-in duration-200",
    overlayLeaveToClass: "opacity-0",
    enterClass: "opacity-0 translate-y-4 sm:translate-y-0 transform sm:scale-95",
    enterActiveClass: "transition ease-out duration-300",
    enterToClass: "opacity-100 translate-y-0 transform sm:scale-100",
    leaveClass: "opacity-100 translate-y-0 transform sm:scale-100",
    leaveActiveClass: "transition ease-in duration-200",
    leaveToClass: "opacity-0 translate-y-4 sm:translate-y-0 transform sm:scale-95",
  };
});

const isShownModal = computed({
  get() {
    return props.value;
  },
  set(value) {
    emit("input", value);
  },
});

const show = () => (isShownModal.value = true);

const close = () => (isShownModal.value = false);

__expose({
  close,
  show,
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_unref(TModal), {
    ref: "pageModal",
    modelValue: isShownModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShownModal).value = $event)),
    classes: modalClasses.value,
    class: "modal-notification",
    "click-to-close": _ctx.clickToClose,
    "esc-to-close": _ctx.escToClose,
    "hide-close-button": "",
    onClosed: close
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isExistSlot)('header', _unref(slots)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "header"),
              _createVNode(_unref(VIconSvg), {
                name: "Close",
                color: "white",
                "color-tag": "stroke",
                class: "icon-close",
                onClick: close
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(isExistSlot)('body', _unref(slots)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "body")
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_click_outside, close]
      ])
    ], undefined, true),
    _: 3
  }, 8, ["modelValue", "classes", "click-to-close", "esc-to-close"]))
}
}

})